import { Component, inject, Input, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { tap } from 'rxjs';

@Component({
    selector: 'sume-monthpicker',
    templateUrl: './monthpicker.component.html',
})
export class MonthpickerComponent implements OnInit {
    @Input() formGroup: FormGroup;
    @Input() controlName: string;
    @Input() label: string;
    @Input() messages: {
        invalid: string;
    };
    @Input() useLastDay: boolean = false; // Opção para usar o último dia do mês

    selectedDate: string | Date = '';
    private BsLocaleService = inject(BsLocaleService);

    constructor() {
        this.BsLocaleService.use('pt-br');
    }

    ngOnInit(): void {
        this.handleFormChanges();
    }

    onDateChange(selectedDate: string | Date): void {
        if (
            !selectedDate ||
            (typeof selectedDate === 'string' &&
                String(selectedDate).trim() === '')
        ) {
            this.formControl.reset();
            return;
        }

        const dateObj = new Date(selectedDate);
        const year = dateObj.getFullYear();
        const month = dateObj.getMonth() + 1;
        let day: number;

        if (this.useLastDay) {
            // Último dia do mês: muda para o primeiro dia do próximo mês e subtrai 1
            day = new Date(year, month, 0).getDate();
        } else {
            // Primeiro dia do mês
            day = 1;
        }

        // Formato ISO: yyyy-mm-dd
        const isoDate = `${year}-${month.toString().padStart(2, '0')}-${day
            .toString()
            .padStart(2, '0')}`;

        this.formControl.setValue(isoDate, {
            emitEvent: true,
        });
    }

    handleFormChanges(): void {
        this.formControl.valueChanges
            .pipe(
                tap(isoDate => {
                    if (isoDate) {
                        // Converter formato ISO para a visualização do datepicker
                        try {
                            const [year, month, day] = isoDate.split('-');
                            // Criar um objeto Date para exibição
                            this.selectedDate = new Date(
                                parseInt(year),
                                parseInt(month) - 1,
                                parseInt(day)
                            );
                        } catch (e) {
                            console.error('Erro ao processar data:', e);
                            this.selectedDate = '';
                        }
                    } else {
                        this.selectedDate = '';
                    }
                })
            )
            .subscribe();
    }

    // Formata a data ISO para exibição no formato MM/YYYY
    formatDateDisplay(isoDate: string): string {
        const [year, month] = isoDate.split('-');
        return `${month}/${year}`;
    }

    get formControl(): AbstractControl {
        return this.formGroup.get(this.controlName);
    }
}
